import { uniq, isArray } from 'lodash'
function getValueOrDefault(val, def) {
  if (typeof(val) === 'undefined') {
    return def;
  }
  return val;
}

function Create(systems, Components) {

  const C = {
    none(component) {
    },
    parallaxTransform(component) {
      return {
        componentType:Components.ParallaxTransform,
        __name:Components.ParallaxTransform.__name,
        create:Components.ParallaxTransform.create,
        args:[
          component
        ]
      }
    },
    scrollTransform(component) {
      return {
        componentType:Components.ScrolLTransform,
        __name:Components.ScrollTransform.__name,
        create:Components.ScrollTransform.create,
        args:[
          component
        ]
      }
    },
    particleTransform(component) { 
      return {
        componentType:Components.ParticleTransform,
        __name:Components.ParticleTransform.__name,
        create:Components.ParticleTransform.create,
        args:[
          component
        ]
      }
    },
    spineTransform(component) { 
      return {
        componentType:Components.SpineTransform,
        __name:Components.SpineTransform.__name,
        create:Components.SpineTransform.create,
        args:[
          component
        ]
      }
    },
    spineStart(component) {
      return new Components.MultiComponent(Components.SpineControl, component, [
        component
      ]);
    },
    spineStop(component) {
      return new Components.MultiComponent(Components.SpineControl, component, [
        component
      ]);
    },
    camera(component) {
      return {
        create:Components.Camera.create,
        componentType:Components.Camera,
        __name:Components.Camera.__name,
        args:[
          component.aspect,
          component.active,
          component.zoom
        ]
      }
    },
    forEachTransform(component) {
      return {
        create:Components.ForEachTransform.create,
        componentType:Components.ForEachTransform,
        __name:Components.ForEachTransform.__name,
        args:[
          component
        ]
      }
    },
    conditionalTransform(component) {
      return {
        create:Components.ConditionalTransform.create,
        componentType:Components.ConditionalTransform,
        __name:Components.ConditionalTransform.__name,
        args:[
          component
        ]
      }
    },
    groupTransform(component) {
      return {
        create:Components.GroupTransform.create,
        componentType:Components.GroupTransform,
        __name:Components.GroupTransform.__name,
        args:[
          component
        ]
      }
    },
    gridTransform(component) {
      return {
        create:Components.GridTransform.create,
        componentType:Components.GridTransform,
        __name:Components.GridTransform.__name,
        args:[
          component
        ]
      }
    },
    onDestroy(component) {
      return {
        create:Components.OnDestroy.create,
        componentType:Components.OnDestroy,
        __name:Components.OnDestroy.__name,
        args:[
        ]
      }
    },
    stateManagerFeature(component) {
      return new Components.MultiComponent(Components.StateManagerFeature, component, [
        component
      ]);

      return {
        create:Components.StateManagerFeature.create,
        componentType:Components.StateManagerFeature,
        __name:Components.StateManagerFeature.__name,
        args:[
          component
        ]
      }
    },
    stateManager(component) {
      return {
        create:Components.StateManager.create,
        componentType:Components.StateManager,
        __name:Components.StateManager.__name,
        args:[
          component
        ]
      }
    },
    leaderboard(component) {
      return {
        create:Components.Leaderboard.create,
        args:[
          component
        ]
      }
    },
    log(component) {
      return {
        create:Components.Log.create,
        args:[
          component
        ]
      }
    },
    giveScore(component) {
      return {
        create:Components.GiveScore.create,
        args:[
          component
        ]
      }
    },
    askInput(component) {
      return {
        create:Components.AskInput.create,
        componentType:Components.AskInput,
        __name:Components.AskInput.__name,
        args:[
          component
        ]
      }
    },
    setTransformProperties(component) {
      return {
        create:Components.SetTransformProperties.create,
        componentType:Components.SetTransformProperties,
        __name:Components.SetTransformProperties.__name,
        args:[
          component
        ]
      }
    },
    allTransforms(component) {
      return {
        create:Components.AllTransforms.create,
        componentType:Components.AllTransforms,
        __name:Components.AllTransforms.__name,
        args:[
          component
        ]
      }
    },
    gotoGame(component) {
      return {
        create:Components.GotoGame.create,
        componentType:Components.GotoGame,
        __name:Components.GotoGame.__name,
        args:[
          component
        ]
      }
    },
    gotoscene(component) {
      return {
        create:Components.GotoScene.create,
        componentType:Components.GotoScene,
        __name:Components.GotoScene.__name,
        args:[
          component
        ]
      }
    },
    slot(component) {
      return new Components.MultiComponent(Components.Slot, component, [
        component.component
      ]);
    },
    text(component) {
      return {
        create:Components.GameText.create,
        componentType:Components.GameText,
        __name:Components.GameText.__name,
        args:[
          component.text,
          component.zIndex,
          component
        ]
      }
    },
    addfixture(component) {
      return {
        create:Components.PhysicsAddFixture.create,
        componentType:Components.PhysicsAddFixture,
        __name:Components.PhysicsAddFixture.__name,
        args:[
          component.type
        ]
      }
    },
    removeComponentFromToy(component) {
      return new Components.MultiComponent(Components.RemoveComponentFromToy, component, [
        component.component
      ]);
    },
    transform(component) {
      return {
        create:Components.Transform.create,
        componentType:Components.Transform,
        __name:Components.Transform.__name,
        args:[
          component.data.pos.x,
          component.data.pos.y,
          component.data.scale.x,
          component.data.scale.y,
          0.5,
          0.5,
          //component.data.zIndex
        ]
      }
    },
    repeater(component) {
      return new Components.MultiComponent(Components.Repeater, component, [
        component.tid,
        component.firetime,
        component.initialDelay,
        component.probability ? component.probability : 1,
        component.times ? component.times : 0
      ]);
    },
    spawner(component) {
      return new Components.MultiComponent(Components.Spawner, component, [
      ]);
    },
    unparent(component) {
      return {
        componentType:Components.Unparent,
        __name:Components.Unparent.__name,
        create:Components.Unparent.create,
        args:[
        ]
      }
    },
    cameraFollows(component) {
      return {
        componentType:Components.CameraFollows,
        __name:Components.CameraFollows.__name,
        create:Components.CameraFollows.create,
        args:[
        ]
      }
    },
    playAnimation(component) {
      return {
        componentType:Components.PlayAnimation,
        __name:Components.PlayAnimation.__name,
        create:Components.PlayAnimation.create,
        args:[
          component.animationName,
          component.loop,
          component.speedMultiplier
        ]
      }
    },

    spriteMask(component) {
      return {
        create:Components.SpriteMask.create,
        args:[
          component.maskTransformIds
        ]
      }
    },
    video(component) {
      return {
        create:Components.Video.create,
        componentType:Components.Video,
        __name:Components.Video.__name,
        args:[
          component.video,
          component.width,
          component.height,
          component.thumbnail
        ]
      }
    },
    sprite(component) {
      return {
        create:Components.Sprite.create,
        componentType:Components.Sprite,
        __name:Components.Sprite.__name,
        args:[
          component.b64 ? component.id : component.sprite,
          component.zIndex,
          component.atlas,
          !!component.atlas,
          component.ost,
          component.os,
          component.anims
        ]
      }
    },
    tiledSprite(component) {
      return {
        create:Components.TiledSprite.create,
        componentType:Components.TiledSprite,
        __name:Components.TiledSprite.__name,
        args:[
          component.texture,
          component.zIndex||0,
          component.atlas,
          !!component.atlas,
          component.sizex || 1,
          component.sizey || 1,
          component.basesizex || 1,
          component.basesizey || 1,
          component
        ]
      }
    },
    tileMap(component) {
      return {
        create:Components.TileMap.create,
        componentType:Components.TileMap,
        __name:Components.TileMap.__name,
        args:[component]
      }
    },
    collisionBox(component) {
      return new Components.MultiComponent(Components.CollisionBox, component, [component.scalex, component.scaley, component.tag]);
    },
    collisionLayers(component) {
      return new Components.MultiComponent(Components.CollisionLayers, component, [component.layerA, component.layerB]);
    },
    collisionWith(component) {
      return new Components.MultiComponent(Components.CollisionWith, component, [component.tags, component.onceOnly, component.onceOnlyTag || false, component.specialTags])
    },
    automove(component) {
      return new Components.MultiComponent(Components.AutoMove, component, [
          component.dx,
          component.dy,
          component.respectRotation
      ]);

    },
    destroy(component) {
      return {
        create:Components.Destroy.create,
        componentType:Components.Destroy,
        __name:Components.Destroy.__name,
        args:[
        ]
      }

    },
    properties(component) {
      return {
        create:Components.Properties.create,
        componentType:Components.Properties,
        __name:Components.Properties.__name,
        args:[
          component.name
        ]
      }
    },
    fetchData(component) {
      return {
        create:Components.FetchData.create,
        componentType:Components.FetchData,
        __name:Components.FetchData.__name,
        args:[
          component
        ]
      }
    },
    fetchTransform(component) {
      return {
        create:Components.FetchTransform.create,
        componentType:Components.FetchTransform,
        __name:Components.FetchTransform.__name,
        args:[
          component
        ]
      }
    },
    setproperties(component) {
      return new Components.MultiComponent(Components.SetProperties, component, [component.properties]);

    },
    changeproperties(component) {
      return new Components.MultiComponent(Components.ChangeProperties, component, [component.properties]);

      return {
        create:Components.ChangeProperties.create,
        args:[
          component.properties
        ]
      }

    },
    limitProperties(component) {
      return new Components.MultiComponent(Components.LimitProperties, component, [component]);

      return {
        create:Components.LimitProperties.create,
        args:[
          component
        ]
      }

    },
    toy(component) {
      return new Components.MultiComponent(Components.CreateToy, component, [component]);
    },
    feature(component) {
      return new Components.MultiComponent(Components.CreateFeature, component, [component]);
    },
    createEntity(component) {
      return new Components.MultiComponent(Components.CreateEntity, component, [component, component.overrideTransform, component.data, parseFloat(component.translatex||0), parseFloat(component.translatey||0)]);
    },
    point(component) {
      return {
        create:Components.Point.create,
        args:[
          component
        ]
      }
    },
    path(component) {
      return {
        create:Components.Path.create,
        args:[
          component
        ]
      }
    },
    followpath(component) {
      return {
        create:Components.FollowPath.create,
        componentType:Components.FollowPath,
        __name:Components.FollowPath.__name,
        args:[
          component.pathId,
          typeof(component.flip) === 'string' ? (component.flip === 'true') : component.flip,
          component.speed,
          component.tween,
          component.changeAngle,
          component.offsetAngle
        ]
      }

    },
    tween(component) {
      return new Components.MultiComponent(Components.Tween, component, [
        component.time,
        component.tweens,
        component.loop,
        component.flip,
        component.startDelay,
        component.v2,
        component.reset,
        component.loopDelay,
        component.flipDelay
      ], true);

    },
    gravity(component) {
      return {
        create:Components.GravityAffected.create,
        args:[
          component.gravity
        ]
      }
    },
    tapcontroller(component) {
      return new Components.MultiComponent(Components.TapController, component, [
        component.tapAnywhere || false,
        component.repeatEnabled || false,
        isNaN(parseFloat(component.cooldown)) ? 0 : parseFloat(component.cooldown),
        component.cooldownEvent,
        component.cooldownKey,
        component
      ]);

      return {
        create:Components.TapController.create,
        args:[
          component.tapAnywhere || false,
          component.repeatEnabled || false
        ]
      }

    },
    keycontroller(component) {
      return {
        create:Components.KeyController.create,
        componentType:Components.KeyController,
        __name:Components.KeyController.__name,
        args:[
        ]
      }

    },

    jump(component) {
      return {
        create:Components.Jump.create,
        componentType:Components.Jump,
        __name:Components.Jump.__name,
        args:[
          component.dx,
          component.dy,
          component.platformTag
        ]
      }

    },
    goal(component) {
      const win = {
        property:component.win.property,
        target:component.win.value
      }
      const lose = {
        property:component.lose.property,
        target:component.lose.value
      }
      return {
        create:Components.Goal.create,
        componentType:Components.Goal,
        __name:Components.Goal.__name,
        args:[
          win,
          lose
        ]
      }
    },
    random(component) {
      return {
        create:Components.Random.create,
        componentType:Components.Random,
        __name:Components.Random.__name,
        args:[
          component.probability
        ]
      }

    },
    moveto(component) {
      return {
        create:Components.MoveTo.create,
        componentType:Components.MoveTo,
        __name:Components.MoveTo.__name,
        args:[
          component.target,
          parseFloat(component.speed),
          component.tween
        ]
      }

    },
    moveHere(component) {
      return {
        create:Components.MoveHere.create,
        componentType:Components.MoveHere,
        __name:Components.MoveHere.__name,
        args:[
          component.tag,
          parseFloat(component.speed),
          component.tween
        ]
      }
    },
    moveto(component) {
      return {
        create:Components.MoveTo.create,
        componentType:Components.MoveTo,
        __name:Components.MoveTo.__name,
        args:[
          component,
        ]
      }

    },
    randomChoose(component) {
      return new Components.MultiComponent(Components.RandomChoose, component, [ ]);

      return {
        create:Components.RandomChoose.create,
        args:[
        ]
      }

    },
    move(component) {
      return new Components.MultiComponent(Components.Move, component, [
          component.dx,
          component.dy,
          component.dscale || 0,
          component.t,
          component.tween || 'linear'
      ]);
    },
    swipecontroller(component) {
      return {
        create:Components.SwipeController.create,
        componentType:Components.SwipeController,
        __name:Components.SwipeController.__name,
        args:[
          component
        ]
      }
    },
    stopmovement(component) {
      return {
        create:Components.StopMovement.create,
        componentType:Components.StopMovement,
        __name:Components.StopMovement.__name,
        args:[
          component.revertToStart
        ]
      }

    },
    setstate(component) {
      return new Components.MultiComponent(Components.SetState, component, [component.stateName, component.stateValue]);
      return {
        create:Components.SetState.create,
        componentType:Components.SetState,
        __name:Components.SetState.__name,
        args:[
          component.stateName,
          component.stateValue
        ]
      }
    },
    setgamestate(component) {
      return {
        create:Components.SetGameState.create,
        componentType:Components.SetGameState,
        __name:Components.SetGameState.__name,
        args:[
          component.state,
          component.message
        ]
      }

    },
    circle(component) {
      return {
        create:Components.Circle.create,
        componentType:Components.Circle,
        __name:Components.Circle.__name,
        args:[
          parseFloat(component.cx),
          parseFloat(component.cy),
          component.radius,
          component.startAngle,
          component.endAngle,
          component.color,
          component.lineColor,
          component.lineWidth,
          component.outline,
          component.fill
        ]
      }
    },
    primitive(component) {
      return {
        create:Components.Shape.create,
        componentType:Components.Shape,
        __name:Components.Shape.__name,
        args:[
          component.shapetype,
          component.color,
          component.zIndex,
          component.stroke,
          component.scalex,
          component.scaley,
          component.lineWidth,
          component.dontCacheAsBitmap,
          component.theme
        ]
      }
    },
    cooldown(component) {
      return new Components.MultiComponent(Components.Cooldown, component, [
        component.cooldown,
        component.cooldownEvent,
        component.cooldownKey
      ]);

    },
    delay(component) {
      return new Components.MultiComponent(Components.Delay, component, [component.delay]);
    },
    playSound(component) {
      return {
        create:Components.PlaySound.create,
        componentType:Components.PlaySound,
        __name:Components.PlaySound.__name,
        args:[
          component.sound,
          component.loop
        ]
      }

    },
    press(component) {
      return {
        create:Components.PressController.create,
        componentType:Components.PressController,
        __name:Components.PressController.__name,
        args:[
          parseFloat(component.horizontalMargin),
          parseFloat(component.verticalMargin),
          component.useTap || false
        ]
      }

    },
    pan(component) {
      return {
        create:Components.PanController.create,
        componentType:Components.PanController,
        __name:Components.PanController.__name,
        args:[
          component
        ]
      }

    },
    target(component) {
      return {
        create:Components.Target.create,
        componentType:Components.Target,
        __name:Components.Target.__name,
        args:[
          component.targetEntity
        ]
      }
    },
    multiple(component) {
      return new Components.MultiComponent(Components.Multiple, component, [
        component
      ]);

      return {
        create:Components.Multiple.create,
        args:[
        ]
      }
    },
    applyjoint(component) {
      return {
        create:Components.ApplyJoint.create,
        componentType:Components.ApplyJoint,
        __name:Components.ApplyJoint.__name,
        args:[
          component.jointType
        ]
      }
    },
    applyforce2d(component) {
      return new Components.MultiComponent(Components.ApplyForce2D, component, [
        parseFloat(component.forcex),
        parseFloat(component.forcey),
        parseFloat(component.offsetx || 0),
        parseFloat(component.offsety || 0),
        parseFloat(component.maxVelocity || 0),
        component
      ]);
    },
    removejoints(component) {
      return {
        create:Components.RemoveJoints.create,
        componentType:Components.RemoveJoints,
        __name:Components.RemoveJoints.__name,
        args:[
        ]
      }
    },
    applyimpulse2d(component) {
      return {
        create:Components.ApplyImpulse2D.create,
        componentType:Components.ApplyImpulse2D,
        __name:Components.ApplyImpulse2D.__name,
        args:[
          parseFloat(component.impulsex),
          parseFloat(component.impulsey),
          parseFloat(component.offsetx || 0),
          parseFloat(component.offsety || 0),
          component.keep || false
        ]
      }
    },
    setbodyproperties(component) {
      return {
        create:Components.SetBodyProperties.create,
        componentType:Components.SetBodyProperties,
        __name:Components.SetBodyProperties.__name,
        args:[
          component
        ]
      }
    },
    setlinearvelocity2d(component) {
      return {
        create:Components.SetLinearVelocity2d.create,
        componentType:Components.SetLinearVelocity2d,
        __name:Components.SetLinearVelocity2d.__name,
        args:[
          component
        ]
      }
    },
    changebodytype(component) {
      return {
        create:Components.ChangeBodyType.create,
        componentType:Components.ChangeBodyType,
        __name:Components.ChangeBodyType.__name,
        args:[
          component.bodyType,
        ]
      }
    },
    delayTransform(component) {
      return {
        create:Components.DelayTransform.create,
        componentType:Components.DelayTransform,
        __name:Components.DelayTransform.__name,
        args:[
          component
        ]
      }
    },
    onTimeline(component) {
      return new Components.MultiComponent(Components.OnTimeline, component, [
        component
      ]);

      return {
        create:Components.OnTimeline.create,
        args:[
          component
        ]
      }
    },
    timeline(component) {
      return new Components.MultiComponent(Components.Timeline, component, [
        component
      ]);
      return {
        create:Components.Timeline.create,
        args:[
          component
        ]
      }
    },
    onEventTransform(component) {
      return {
        create:Components.OnEventTransform.create,
        componentType:Components.OnEventTransform,
        __name:Components.OnEventTransform.__name,
        args:[
          component
        ]
      }
    },
    randomTransform(component) {
      return {
        create:Components.RandomTransform.create,
        componentType:Components.RandomTransform,
        __name:Components.RandomTransform.__name,
        args:[
          component
        ]
      }
    },
    setcollisionfilter(component) {
      return {
        create:Components.SetCollisionFilter.create,
        componentType:Components.SetCollisionFilter,
        __name:Components.SetCollisionFilter.__name,
        args:[
          component.categoryBits,
          component.maskBits,
          component.groupIndex
        ]
      }
    },
    physicsbody2d(component) {
      return {
        create:Components.PhysicsBody2D.create,
        componentType:Components.PhysicsBody2D,
        __name:Components.PhysicsBody2D.__name,
        args:[
          component.bodyType,
          component.sceneData,
          component.ignoreRotation || false,
          component.isFixedRotation || false,
          parseFloat(getValueOrDefault(component.density, 1)),
          parseFloat(getValueOrDefault(component.friction, 1)),
          parseFloat(getValueOrDefault(component.restitution, 0.25)),
          parseFloat(getValueOrDefault(component.linearDamping, 0)),
          parseFloat(getValueOrDefault(component.angularDamping, 0)),
          component.isSensor || false,
          component.shapeType || 'box',
          component.categoryBits,
          component.maskBits,
          component.groupIndex,
          component.id,
          parseFloat(component.scale || 1),
          typeof(component.gravityScale) !== 'undefined' ? parseFloat(component.gravityScale) : 1,
          component
        ]
      }
    },
    prefab(component) {
      return {
        create:Components.Multiple.create,
        args:[
        ]
      }
    },
    translate(component) {
      return new Components.MultiComponent(Components.Translate, component, [
        component.dx,
        component.dy,
        component.dr,
        component.dsx,
        component.dsy,
        component.translateType || 'add',
        component.keep || false,
        component.lerpt || 0.5
      ], true);

      return {
        create:Components.Translate.create,
        componentType:Components.Translate,
        __name:Components.Translate.__name,
        args:[
          component.dx,
          component.dy,
          component.dr,
          component.dsx,
          component.dsy,
          component.translateType || 'add',
          component.keep || false
        ]
      }
    },
    emitEvent(component) {
      return new Components.MultiComponent(Components.EmitEvent, component, [component.eventName, component.localEvent]);
    },
    onEvent(component) {
      return new Components.MultiComponent(Components.OnEvent, component, [component.eventName, false]);
    },
    sequence(component) {
      return new Components.MultiComponent(Components.Sequence, component, [
      ]);
    },
    script(component) {
      return new Components.MultiComponent(Components.LuaScript, component, [
          component,
          systems.findRoot()
      ], true)

      return {
        create:Components.LuaScript.create,
        args:[
        ]
      }
    },
    restrictPosition(component) {
      return {
        create:Components.RestrictPosition.create,
        componentType:Components.RestrictPosition,
        __name:Components.RestrictPosition.__name,
        args:[
          parseFloat(component.minX),
          parseFloat(component.minY),
          parseFloat(component.maxX),
          parseFloat(component.maxY),
        ]
      }
    }




  }
  function createEntityFromComponent(gameobjects, component) {
    const entity = gameobjects.entities.createEntity();

    addTreeOfComponents(gameobjects, component, entity);

    return entity;

  }

  function getFirstLevelOfComponents(gameobjects, c) {
    return uniq(_getFirstLevelOfComponents(gameobjects, c), (c) => {
      return c.id;
    });
  }
  function _getFirstLevelOfComponents(gameobjects, c) {
    const components = [];
    const source = c.id;
    const linkedFrom = gameobjects.componentLinkCache[c.id + '-__ALL_LINKS'];
    const length = linkedFrom.length;
    for (var i = 0; i < length; i++ ) {
      const link = linkedFrom[i];
      const component = findComponent(
        gameobjects, link.target
      );
      components.push(component);
    }

    return components;

  }

  function addFirstLevelOfComponents(gameobjects, c, ent) {
    const source = c.id;
    const linkedFrom = gameobjects.componentLinkCache[c.id + '-__ALL_LINKS'];
    /*
  const linkedFrom = gameobjects.links.filter( (x) => {
    return source === x.source;
  });
  */
    const length = linkedFrom.length;
    for (var i = 0; i < length; i++ ) {
      const link = linkedFrom[i];
      const component = findComponent(
        gameobjects, link.target
      );
      addComponentToLink(gameobjects, ent, component);
    }

  }

  function addTreeOfComponents(gameobjects, c, ent) {
    const source = c.id;
    const linkedFrom = gameobjects.componentLinkCache[c.id + '-__ALL_LINKS'];

    const length = linkedFrom.length;
    for (var i = 0; i < length; i++ ) {
      const link = linkedFrom[i];
      const component = findComponent(
        gameobjects, link.target
      );
      addComponentToLink(gameobjects, ent, component);
      addTreeOfComponents(gameobjects, component, ent);
    }


  }


  function addComponentToLink(gameobjects, entity, component) {
    return addComponent(entity, component);
  };

  function addComponent(entity, component, data=undefined) {
    if (!entity._manager) {
      return;
    }
    if (!component) {
      console.warn('unknown component');
      return;
    }
    let comp;
    const t1 = new Date().getTime();
    if (isArray(component)) {
      const length = component.length;
      for (var i = 0; i < length; i++) {
        let tt1 = new Date().getTime();
        const c = component[i];
        if (c.disabled) {
          continue;
        }
        const createObject = create(c);
        if (createObject) {
          comp = createObject.create.apply(createObject, [entity].concat(createObject.args));
          if (data) {
            systems.setComponentExtraData(entity, c, data);
          }
          if (comp.setData) {
            comp.setData(data);
          }
          comp.id = c.id;
          comp.__componentType = createObject.componentType;
        }
        let tt2 = new Date().getTime();
      }
    } else {
      if (component.disabled) {
        return;
      }
      const createObject = create(component);
      if (createObject) {
        comp = createObject.create.apply(createObject, [entity].concat(createObject.args));
        if (data) {
          systems.setComponentExtraData(entity, component, data);
        }
        if (comp.setData) {
          comp.setData(data);
        }
        comp.id = component.id;
        comp.__componentType = createObject.componentType;
      }
    }
    const t2 = new Date().getTime();
    return comp;
    //if (t2 - t1 >= 4) {
      //console.log('LONG!!', component.type, component.id);
    //}
  };

function findComponent(gameobjects, id) {
  return gameobjects.componentIdCache[id];
  /*
  const x = gameobjects.components.filter( (c) => {
    return c.id === id;
  } );
  if (x) {
    return x[0];
  }
  return null;
  */
}
  function create(component) {
    const func = C[component.type];
    if (func) {
      const d = func(component);
      //console.log('t2-t1', t2-t1);
      //if (t2 - t1 > 8) {
        //console.log('took to long', component);
      //}
      return d;
    } else {
      console.error('dont know', component);
    }
  };
  return {
    create,
    createEntityFromComponent,
    addTreeOfComponents,
    addFirstLevelOfComponents,
    findComponent,
    getFirstLevelOfComponents,
    addComponent,
    addComponentToLink
  }

}

export default Create
